<template>
    <div class="row pt-2">
        <div class="d-flex justify-content-start align-items-center w-100">
            <div class="w-50 pe-4">
                <QuantityInput :product="product" @update-quantity="product.quantity = $event"/>
            </div>

            <ProductStockIndicator :product="product"/>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col">
            <CartButtonProductPage :product="product" :quantity="product.quantity"/>
        </div>
    </div>
</template>

<script setup>
const ProductStockIndicator = defineAsyncComponent(() => import("~/components/Product/ProductStockIndicator.vue"));
const CartButtonProductPage = defineAsyncComponent(() => import('~/components/Product/Buttons/CartButtonProductPage.vue'));
const QuantityInput = defineAsyncComponent(() => import("~/components/Product/QuantityInput.vue"));

const props = defineProps({
    product: Object
});
</script>


